import React from 'react';
import IconButton from '@material-ui/core/IconButton/IconButton';
import Paper from '@material-ui/core/Paper/Paper';
import CancelIcon from '@material-ui/icons/Cancel';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import SwapVertIcon from '@material-ui/icons/SwapVert';
import { isFreePlan } from '../../../../../utils/helper';
import Loading from '../../../../Common/Loading';
import styles from '../styles';

const PlanTile = ({ account, onCancelAccount, onUpgrade }) => {
  return (<Paper style={styles.planContainer}>
    {account ?
      <div style={styles.row}>
        <div style={{ flex: 1 }}>
          <div style={styles.paperTitle}>Current Plan</div>
          <div style={styles.paperBody}>
            {isFreePlan(account) ? 'Free' : account.settings.plan.split('-')[0]}
          </div>
        </div>
        <div style={styles.actionButton}>
          <Tooltip placement="bottom" title="Upgrade">
            <IconButton
              onClick={onUpgrade}
            >
              <SwapVertIcon style={styles.icon}/>
            </IconButton>
          </Tooltip>
          <Tooltip placement="bottom" title="Cancel Account">
            <IconButton
              onClick={onCancelAccount}
            >
              <CancelIcon style={styles.icon} color="error"/>
            </IconButton>
          </Tooltip>
        </div>
      </div> : <Loading/>}
  </Paper>);
};

export default PlanTile;



// WEBPACK FOOTER //
// ./src/components/Admin/Billing/BillingView/tiles/PlanTile.js